(function() {
  if (window._tosListenerAdded) return;
  window._tosListenerAdded = true;

  document.body.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'myCheckbox') {
      var display = e.target.checked ? 'none' : 'block';
      document.querySelectorAll('#tos-blocker, #tos-blocker-express').forEach(function(b) {
        b.style.setProperty('display', display, 'important');
      });
    }
  });
})();

